import React from 'react';
import { View, Platform } from 'react-native';
import { createStyleSheet } from '../../../utils';
import { useStyleSheet } from '../../../hooks';
import { Text } from '../../Text';
import { IconButton } from '../../IconButton';
import { Checkbox } from '../../Checkbox';
import Interval from './Interval';
import { useAvailabilityEditorContext } from '../hooks';
export const Day = ({ name, day }) => {
    const styles = useStyleSheet(getStyles);
    const { data, toggle, add } = useAvailabilityEditorContext();
    return (React.createElement(View, { style: styles.container },
        React.createElement(View, { style: styles.title },
            React.createElement(View, { style: styles.checkboxWrapper },
                React.createElement(Checkbox, { onChange: () => {
                        toggle(day);
                    }, checked: !!data[day].length })),
            React.createElement(Text, { style: styles.name, type: 'body', size: 'lg', weight: 'regular' }, name)),
        React.createElement(View, { style: styles.intervals }, data[day].map((value, index) => (React.createElement(Interval, { style: [
                styles.interval,
                index !== 0 ? styles.intervalWithMargin : {}
            ], value: value, day: day, key: index })))),
        React.createElement(IconButton, { value: 'add', onPress: () => {
                add(day);
            }, type: 'tertiary', accent: 'neutral', style: styles.add, size: 'sm' })));
};
const getStyles = createStyleSheet(({ color, size }) => ({
    // @ts-expect-error react-native does not support string for zIndex
    container: Object.assign({ flexDirection: 'row', alignItems: 'flex-start', flexWrap: 'wrap', marginTop: -size.G }, (Platform.OS === 'web' ? { zIndex: 'unset' } : {})),
    interval: {},
    intervalWithMargin: {
        marginTop: size.G
    },
    // @ts-expect-error react-native does not support string for zIndex
    intervals: Object.assign({ marginRight: size.N, marginTop: size.G, marginLeft: size.J + 2 * size.C }, (Platform.OS === 'web' ? { zIndex: 'unset' } : {})),
    name: {
        color: color.invert2.p100,
        marginLeft: size.C
    },
    checkboxWrapper: { padding: size.B },
    title: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingVertical: size.B,
        width: size.P + size.M,
        marginTop: size.G
    },
    add: {
        position: 'absolute',
        top: size.G,
        right: 0
    }
}));
//# sourceMappingURL=Day.js.map